function hashBusinessKey(businessKey: string): number {
  let hash = 0;
  for (const char of businessKey) {
    hash = (hash * 31 + (char.codePointAt(0) ?? 0)) % 1_000_000;
  }
  return hash;
}

/**
 * Deterministic stand-in for a real Orion account-opening endpoint (no
 * endpoint exists yet — see #25466). Produces a plausible-looking account
 * number so the recap screen has something to display.
 */
export function generateMockAccountNumber(businessKey: string): string {
  const suffix = hashBusinessKey(businessKey).toString().padStart(6, "0");
  return `CPT-${suffix}`;
}
